import React, {PureComponent} from 'react'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {User} from '../Model'
import history from 'helpers/History'
import {Table} from 'components'

interface Props {
  store?: Store
}

@inject('store')
@observer
class UsersTable extends PureComponent<Props, object> {
  componentDidMount() {
    this.props.store!.users.read()
  }

  handleSelectItem = (user: User) => {
    history.push(`/users/${user.id}`)
  }

  handleCreate = () => {
    history.push(`/users/create`)
  }

  render() {
    const {users} = this.props.store!

    const headers = this.props.store!.UI.isDesktop
      ? ['name', 'lastname', 'username', 'role', 'city', 'phone', 'email']
      : ['name', 'lastname', 'role']

    return (
      <Table
        items={users.users}
        header={headers}
        onSelectItem={this.handleSelectItem}
        onCreate={this.handleCreate}
        keyExtractor={(user: User) => String(user.id)}
        loading={!users.loaded}
      />
    )
  }
}

export default UsersTable



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Users/containers/UsersTable.tsx